export const mobile = {
  'backoffice.mobile.tabs.home': 'Home',
  'backoffice.mobile.tabs.accounts': 'Accounts',
  'backoffice.mobile.tabs.profits': 'Profits',
  'backoffice.mobile.tabs.commissions': 'Commissions',
  'backoffice.mobile.tabs.more': 'More',
  'backoffice.mobile.more.myProfitHistory': 'My Profit History',
};
